﻿import { createPopper } from '@popperjs/core';

export const tooltipState = function () {
	return {
		/**
		 * STATE. Poppe Instance
		 */
		instance: null,

		/**
		 * STATE. Trigger Element
		 */
		triggerEl: null,

		/**
		 * STATE. Content Element
		 */
		contentEl: null,

		isOpen: false,

		/**
		 * INIT METHOD. Creates popper instance, sets elements to component state
		 * 
		 * @param {Element} triggerEl
		 * @param {Element} contentEl
		 * @param {object} options
		 */
		setupInstance: function (triggerEl, contentEl, options) {
			this.triggerEl = triggerEl;
			this.contentEl = contentEl;
			this.instance = createPopper(triggerEl, contentEl, options);
		},

		/**
		 * METHOD. Show Popper Content
		 * 
		 * Returns a boolean to help in setting open/closed state and transitions in Alpine
		 *
		 * @param {any} contentEl
		 * @param {any} popperInstance
		 * @returns {boolean}
		 */
		show: function () {
			this.contentEl.setAttribute('data-show', '');

			this.instance.setOptions({
				modifiers: [{ name: 'eventListeners', enabled: true }],
			});

			this.instance.update();

			return true;
		},

		/**
		 * METHOD. Hide Popper Content
		 * 
		 * Hides the popper element. Also disables eventListeners when hidden, {@link https://popper.js.org/docs/v2/tutorial/#performance} supposedly helps with performance.
		 *
		 * Returns a boolean to help in setting open/closed state and transitions in Alpine
		 *
		 * @param {any} contentEl
		 * @param {any} popperInstance
		 * @returns {boolean}
		 */
		hide: function () {
			this.contentEl.removeAttribute('data-show');

			this.instance.setOptions({
				modifiers: [{ name: 'eventListeners', enabled: false }],
			});

			this.instance.update();

			return false;
		},
	};
};
